"use client";

import { UserPlus } from "lucide-react";
import { useReferralInviteStore } from "modules/city/stores/useReferralInviteStore";

interface CityHubInviteCtaProps {
  cityName: string;
  cityUrl: string;
}

export function CityHubInviteCta({ cityName, cityUrl }: CityHubInviteCtaProps) {
  const openModal = useReferralInviteStore((state) => state.openModal);
  const cityLabel = cityName.includes(",")
    ? cityName.split(",")[0]!.trim()
    : cityName;

  return (
    <section
      aria-labelledby="city-invite-heading"
      className="card card-border border-base-content/15 bg-base-200"
    >
      <div className="card-body gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <span className="bg-base-100 flex size-11 shrink-0 items-center justify-center rounded-full">
            <UserPlus size={21} aria-hidden="true" />
          </span>
          <div>
            <h2 id="city-invite-heading" className="card-title text-lg">
              Know someone who trades in {cityLabel}?
            </h2>
            <p className="text-base-content/65 mt-1 text-sm">
              Invite them to join the trading network.
            </p>
          </div>
        </div>
        <div className="card-actions sm:shrink-0">
          <button
            type="button"
            className="btn btn-primary"
            aria-haspopup="dialog"
            onClick={() => openModal({ context: "unlocked", cityUrl })}
          >
            Invite a trader
          </button>
        </div>
      </div>
    </section>
  );
}
